import React from 'react';
import { Card, CardContent, CardHeader, Divider } from '@material-ui/core';
import useAsync from 'react-use/lib/useAsync';
import { Progress } from '@backstage/core-components';
import { useFetchFile } from '../../hooks/useCXOneReport.ts';
import { useEntity } from '@backstage/plugin-catalog-react';
import { stringifyEntityRef } from '@backstage/catalog-model';

export const CXOneCard = () => {
  const { entity } = useEntity();
  const ref = stringifyEntityRef({
    kind: entity.kind,
    namespace: entity.metadata.namespace,
    name: entity.metadata.name,
  });

  const fetchFile = useFetchFile();

  const { value, loading } = useAsync(async () => {
    return fetchFile(ref);
  }, []);

  if (loading) {
    return <Progress />;
  }
  if (!value || Object.keys(value).length === 0) {
    return (
      <Card>
        <CardHeader title="CXOne Report" />
        <Divider />
        <CardContent>
          <p>No CXOne Report found for this entity.</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader title="CXOne Report" />
      <Divider />
      <CardContent>
        <iframe
          src={value}
          title="Secure PDF Viewer"
          width="100%"
          height="100%"
          style={{ border: 'none', minHeight: '900px' }}
        />
      </CardContent>
    </Card>
  );
};
